module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "workbench-overview"
  }, [_c('el-card', {
    staticClass: "overview-card"
  }, [_c('div', {
    staticClass: "overview-content"
  }, [_c('div', {
    staticClass: "data-item"
  }, [_c('div', {
    staticClass: "data-label"
  }, [_vm._v("总客户量")]), _vm._v(" "), _c('div', {
    staticClass: "data-icon"
  }, [_c('i', {
    staticClass: "el-icon-user-solid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(this.totalRecords.newCustomers))])]), _vm._v(" "), _c('div', {
    staticClass: "data-item"
  }, [_c('div', {
    staticClass: "data-label"
  }, [_vm._v("总销售额")]), _vm._v(" "), _c('div', {
    staticClass: "data-icon"
  }, [_c('i', {
    staticClass: "el-icon-money"
  })]), _vm._v(" "), _c('div', {
    staticClass: "data-value"
  }, [_vm._v("¥" + _vm._s(this.totalRecords.salesAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "data-item"
  }, [_c('div', {
    staticClass: "data-label"
  }, [_vm._v("总订单量")]), _vm._v(" "), _c('div', {
    staticClass: "data-icon"
  }, [_c('i', {
    staticClass: "el-icon-s-order"
  })]), _vm._v(" "), _c('div', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(this.totalRecords.totalOrders))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('date-selection', {
    staticClass: "time",
    attrs: {
      "hasBorder": true
    },
    on: {
      "confirm-selection": _vm.fetchData
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.info))]), _vm._v(" "), _c('div', {
    staticClass: "stats-row"
  }, [_c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("总订单量")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalOrders))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.totalOrdersChange > 0 ? 'positive' : (_vm.totalOrdersChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.totalOrdersChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.totalOrdersChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.totalOrdersChange !== 0) ? [_vm._v("\n                " + _vm._s(_vm.totalOrdersChange > 0 ? '增加' : '减少') + "\n                " + _vm._s(Math.abs(_vm.totalOrdersChange)) + "%\n              ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段订单量：" + _vm._s(_vm.totalOrders))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "订单量：" + _vm._s(_vm.previousTotalOrders))]), _vm._v(" "), (_vm.totalOrdersChange !== 0) ? _c('p', [_vm._v("\n                      环比变化：" + _vm._s(_vm.totalOrdersChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.totalOrdersChange)) + "%\n                    ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)]), _vm._v(" "), _c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("销量金额")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v("¥" + _vm._s(_vm.formatAmount(_vm.salesAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.salesAmountChange > 0 ? 'positive' : (_vm.salesAmountChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.salesAmountChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.salesAmountChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.salesAmountChange !== 0) ? [_vm._v("\n                " + _vm._s(_vm.salesAmountChange > 0 ? '增加' : '减少') + "\n                " + _vm._s(Math.abs(_vm.salesAmountChange)) + "%\n              ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段销量金额：¥" + _vm._s(_vm.salesAmount))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "销量金额：¥" + _vm._s(_vm.previousSalesAmount))]), _vm._v(" "), (_vm.salesAmountChange !== 0) ? _c('p', [_vm._v("\n                      环比变化：" + _vm._s(_vm.salesAmountChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.salesAmountChange)) + "%\n                    ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)]), _vm._v(" "), _c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("新增客户")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.newCustomers))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.newCustomersChange > 0 ? 'positive' : (_vm.newCustomersChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.newCustomersChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.newCustomersChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.newCustomersChange !== 0) ? [_vm._v("\n                " + _vm._s(_vm.newCustomersChange > 0 ? '增加' : '减少') + "\n                " + _vm._s(Math.abs(_vm.newCustomersChange)) + "%\n              ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段新增客户：" + _vm._s(_vm.newCustomers))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "新增客户：" + _vm._s(_vm.previousNewCustomers))]), _vm._v(" "), (_vm.newCustomersChange !== 0) ? _c('p', [_vm._v("\n                      环比变化：" + _vm._s(_vm.newCustomersChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.newCustomersChange)) + "%\n                    ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "announcement-list"
  }, _vm._l((_vm.announcements), function(announcement) {
    return _c('div', {
      key: announcement.id,
      staticClass: "announcement-item"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "trigger": "click",
        "width": "300"
      }
    }, [_c('p', [_vm._v(_vm._s(announcement.noticeText))]), _vm._v(" "), _c('span', {
      staticClass: "announcement-title",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n          " + _vm._s(announcement.title) + "\n        ")])]), _vm._v(" "), _c('span', {
      staticClass: "announcement-time"
    }, [_vm._v("\n            " + _vm._s(announcement.createTime) + "\n      ")])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('mydateOrder')], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-container"
  }, [_c('mydateAmount')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "customer"
  }, [_c('CustomerTrendChart')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "announcement-header"
  }, [_vm._v("\n          公告通知\n          "), _c('div', {
    staticClass: "header-line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5fe812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/myData.vue
// module id = 1001
// module chunks = 3